import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GeneralTable from 'src/theme/GeneralTable';

export default function TestTable() {
  let navigate = useNavigate();
  const [prList, setPrList] = useState([
    { id: 1, docEntry: 10, u_pendingAtName: 'Mansoor' },
    { id: 2, docEntry: 11, u_pendingAtName: 'Mansoor Ishaq' },
  ]);
  const rowClicked = (row) => {
    //console.log(row);
    navigate(`/app/myrequests/${row.docEntry}`);
  };
  return (
    <div>
      {' '}
      <GeneralTable
        columns={columns}
        data={prList}
        rowClickedCallback={rowClicked}
        // pageCount={pageCount}
      />
    </div>
  );
}
const columns = [
  {
    Header: 'id',
    accessor: 'id',
  },
  {
    Header: 'Doc #',
    accessor: 'docEntry',
  },
  {
    Header: 'Pending At',
    accessor: 'u_pendingAtName',
  },
];
